import React, {useCallback, useContext, useEffect, useState} from 'react';
import {ContattaciStyle} from "../../styles/pages/contact/ContattaciStyle";
import {
	Backdrop, Button, Checkbox,
	CircularProgress, DialogActions, DialogContentText,
	Divider, FormControlLabel, Menu, MenuItem, Paper, Typography
} from "@mui/material";
import {useHistory, useParams} from "react-router-dom";
import {BaseStyle} from "../../styles/shared/BaseStyle";
import clsx from 'clsx';
import ArrowBackTwoToneIcon from "@mui/icons-material/ArrowBackTwoTone";
import {useForm, FormProvider} from "react-hook-form";
import Grid from "@mui/material/Grid";
import {AppContext, TicketContext} from "../../App";
import {generateTicket, resetAddTicket} from "../../services/TicketServices";
import {setCloseSnackbar, setLang, setOpenSnackbar, setThemeType} from "../../services/AppServices";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from '@mui/material/Alert';
import Background from "../../assets/newbg.jpg";
import IconButton from "@mui/material/IconButton";
import Brightness4TwoToneIcon from "@mui/icons-material/Brightness4TwoTone";
import Brightness5TwoToneIcon from "@mui/icons-material/Brightness5TwoTone";
import Tooltip from "@mui/material/Tooltip";
import {getTicketData} from "../../services/utils/TicketApiData";
import {getCategoryByLabel} from "../../utils/GenericUtils";
import SimpleDialog from "../widgets/dialogs/SimpleDialog";
import {useTheme} from "@mui/styles";
import {AnagraficaTicket} from "../widgets/common/AnagraficaTicket";
import {langDict, languages} from "../../strings/LanguageDictionary";
import GTranslateTwoToneIcon from "@mui/icons-material/GTranslateTwoTone";


const TicketCallPage = () => {
	let history = useHistory();
	const contattaciClasses = ContattaciStyle();
	const classes = BaseStyle();
	let theme = useTheme();
	const methods = useForm({mode: "onChange",});
	const ticketContext = useContext(TicketContext);
	const appContext = useContext(AppContext);
	let {categoria} = useParams();
	const [submit, setSubmit] = useState(false);
	const [openInformativa, setOpenInformativa] = useState(true);
	const [read, setRead] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (key) => {
		if (key) {
			setLang(key, appContext.dispatch)
		}
		setAnchorEl(null);
	};

	const handleCloseSnack = useCallback(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch]);

	const onSubmit = useCallback((data) => {
		if (categoria === "esoneri_vaccinali") {
			alert("Attenzione: non è possibile aprire una richiesta di chiamata per un esonero vaccinale.\n" +
				"Usa i ticket cliccando sul bottone \"Apri un ticket\"! (che trovi nella scheda dedicata agli esoneri)");
		} else {
			setSubmit(true);
			generateTicket(
				getTicketData(
					{
						...data,
						sendMail: false,
						contattoMail: false,
						dettaglioRichiesta: "#RICHIESTA_CHIAMATA",
						categoria: getCategoryByLabel(categoria),
					},
					"Nuovo",
					[],
					[],
					"EXT"),
				ticketContext.dispatch)
		}
	}, [ticketContext.dispatch, categoria])

	const goToHome = useCallback(() => {
		history.push("/contattaci");
	}, [history])

	useEffect(() => {
		if (!ticketContext.state.loadingAddTicket && ticketContext.state.errorAddTicket === "") {
			setOpenSnackbar("success", "Ticket registrato con successo! Ora puoi chiudere questa scheda o continuare a consultare le FAQ", appContext.dispatch);
			setSubmit(false);
			resetAddTicket(ticketContext.dispatch);
			history.push("/contattaci");
		} else if (!ticketContext.state.loadingAddTicket && ticketContext.state.errorAddTicket !== "") {
			setOpenSnackbar("error", ticketContext.state.errorAddTicket, appContext.dispatch);
			setSubmit(false);
		}
	}, [appContext.dispatch, ticketContext.state.loadingAddTicket, ticketContext.state.errorAddTicket, history, ticketContext.dispatch])

	useEffect(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch])

	useEffect(() => {
		document.body.style =
			`background-image: url(${Background});
		background-attachment: fixed;
    background-size: cover;`;
	}, []);

	return (
        <React.Fragment>
            <Backdrop className={classes.backdrop} open={submit} style={{zIndex: 6000}}>
				<CircularProgress color="inherit"/>
			</Backdrop>
            <main className={classes.mainNoBgCol}>
				<header className={contattaciClasses.header}>
					<Tooltip
						title={appContext.state.theme.palette.mode === "light" ? languages[appContext.state.lang].OCEAN__MAIN_GLOBAL_THEMA_TEXT : languages[appContext.state.lang].OCEAN__GLOBAL_THEMA_TEXT_DARK}>
						<IconButton
                            className={contattaciClasses.icon}
                            color="inherit"
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
								appContext.state.theme, appContext.dispatch)}
                            size="large">
							{
								appContext.state.theme.palette.mode === "light" ?
									<Brightness4TwoToneIcon/> :
									<Brightness5TwoToneIcon/>
							}
						</IconButton>
					</Tooltip>
					<Tooltip title={languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}>
						<Button
							className={contattaciClasses.translateButton}
							color="inherit"
							style={{color: appContext.state.theme.palette.mode === "light" ? "#FFF" : "#000", borderRadius: 24}}
							onClick={handleClick}
							startIcon={<GTranslateTwoToneIcon/>}
						>
							{languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}
						</Button>
					</Tooltip>
					<Menu
						PaperProps={{
							className: clsx(classes.roundBorder, classes.transparent, classes.blurred20, classes.shadow24)
						}}
						anchorEl={anchorEl}
						keepMounted
						open={Boolean(anchorEl)}
						onClose={() => handleClose()}
					>
						{
							Object.entries(langDict).map(([key, val]) => {
								return (
									<MenuItem style={{width: 300}} key={key} onClick={() => handleClose(key)}>{val.flag}<span
										style={{paddingLeft: 8}}>{val.label}</span></MenuItem>
								)
							})
						}
					</Menu>
					<Typography variant={"h2"} component={"h1"} className={contattaciClasses.title}>
						<b>{languages[appContext.state.lang].CONTATTACI_REQUIRE_CALL_TITLE}</b>
					</Typography>
				</header>
				<article className={contattaciClasses.article}>
					<Paper
						className={clsx(classes.roundBorder, contattaciClasses.mdWidth, classes.transparent, classes.blurred20)}>
						<form onSubmit={methods.handleSubmit(onSubmit)}>
							<FormProvider {...methods}>
								<Grid container spacing={3}>
									<AnagraficaTicket classes={classes} isCallReq={true}/>

									<Grid item xs={12}>
										<Divider/>
									</Grid>
									<Grid item xs={12}>
										<Typography color={"textSecondary"}>
											{languages[appContext.state.lang].CONTATTACI_INFO_CALL_RESPONSE}
										</Typography>
									</Grid>

									<Grid item xs={12} style={{display: "flex", justifyContent: "center"}}>
										<Button variant={"contained"} color={"primary"} disableElevation className={classes.roundButton}
										        style={{borderRadius: 24, fontSize: 18}}
										        onClick={methods.handleSubmit(onSubmit)} disabled={submit}>
											<b>{languages[appContext.state.lang].CONTATTACI_REQUIRE_CALL_TITLE}</b>
										</Button>
									</Grid>

								</Grid>
							</FormProvider>
						</form>
					</Paper>
					<Button className={clsx(classes.roundBorder, classes.margin2, classes.blurred20)}
					        size={"small"} variant={"contained"} color={"primary"}
					        style={{borderRadius: 24}}
					        startIcon={<ArrowBackTwoToneIcon/>} onClick={goToHome}>
						{languages[appContext.state.lang].CONTATTACI_RETURN_HOME_BUTTON}
					</Button>
				</article>
			</main>
            <Snackbar open={appContext.state.open} autoHideDuration={3000} onClose={handleCloseSnack}>
				<Alert style={{borderRadius: 28}} onClose={handleCloseSnack}
				       severity={appContext.state.severity}>
					{appContext.state.message}
				</Alert>
			</Snackbar>
            <SimpleDialog
				open={openInformativa}
				title={languages[appContext.state.lang].CONTATTACI__BENVENUTO__TITLE_}
				content={
					<DialogContentText component={"div"}>
						{languages[appContext.state.lang].CONTATTACI_INFORMATIVA_PRIVACY}
						<a style={{color: theme.palette.primary.main}}
						   href={"http://www.aslcittaditorino.it/privacy/"}
						   target="_blank"
						   rel="noopener noreferrer">http://www.aslcittaditorino.it/privacy/</a> {languages[appContext.state.lang].CONTATTACI_INFORMATIVA_PRIV_2_}.<br/>
						<FormControlLabel
							control={
								<Checkbox
									color={"primary"}
									checked={read}
									onChange={() => setRead(!read)}
									name="read"/>
							}
							label={languages[appContext.state.lang].CONTATTACI_READ_CONFIRM_PRIV_}
						/>
					</DialogContentText>
				}
				actions={
					<DialogActions>
						<Tooltip title={languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}>
							<Button
								color="inherit"
								style={{color: appContext.state.theme.palette.mode === "light" ? "#000" : "#FFF", borderRadius: 24}}
								onClick={handleClick}
								startIcon={<GTranslateTwoToneIcon/>}
							>
								{languages[appContext.state.lang].CONTATTACI_CHANGE_LANG_BUTTON}
							</Button>
						</Tooltip>
						<Menu
							PaperProps={{
								className: clsx(classes.roundBorder, classes.transparent, classes.blurred20, classes.shadow24)
							}}
							anchorEl={anchorEl}
							keepMounted
							open={Boolean(anchorEl)}
							onClose={() => handleClose()}
						>
							{
								Object.entries(langDict).map(([key, val]) => {
									return (
										<MenuItem style={{width: 300}} key={key} onClick={() => handleClose(key)}>{val.flag}<span
											style={{paddingLeft: 8}}>{val.label}</span></MenuItem>
									)
								})
							}
						</Menu>
						<Button variant={"contained"} disableElevation size={"small"} className={classes.roundButton}
						        color={"primary"} style={{borderRadius: 24}}
						        onClick={() => setOpenInformativa(false)} disabled={!read}>
							<b>{languages[appContext.state.lang].CONTATTACI__CONFERMO_PRIVACY_}</b>
						</Button>
					</DialogActions>
				}
			/>
        </React.Fragment>
    );
};

function Alert(props) {
	return <MuiAlert elevation={16} variant="filled" {...props} />;
}

export default React.memo(TicketCallPage);
